import { render } from "./SwiperSlider.vue?vue&type=template&id=2c9d5d69"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__